import { createStyles, makeStyles, Theme } from "@material-ui/core";

interface LynxCheckBoxStylesProps {
    checked?: boolean;
    // Medium corresponds to large in the design system
    size?: "small" | "medium";
    disabled?: boolean;
}

export const lynxCheckBoxStyles = makeStyles((theme: Theme) =>
    createStyles({
        labelRoot: {
            margin: 0,

            "& .MuiTypography-body1": {
                ...theme.typography.body2,
                color: ({ disabled }: LynxCheckBoxStylesProps) =>
                    disabled
                        ? theme.colors.neutrals.neutral300
                        : theme.colors.neutrals.neutral500,
            },
        },

        checkboxRoot: {
            padding: 0,
            marginRight: theme.spacing(1),
            borderRadius: theme.shape.borderRadius,

            "&.MuiIconButton-root:hover": {
                background: "initial",
            },

            "&.MuiIconButton-colorSecondary:hover": {
                background: "initial",
            },

            "&:focus-within": {
                boxShadow: theme.focusShadow,
            },
        },

        icon: {
            width: ({ size }: LynxCheckBoxStylesProps) =>
                size === "small" ? 16 : 24,
            height: ({ size }: LynxCheckBoxStylesProps) =>
                size === "small" ? 16 : 24,

            backgroundColor: ({
                disabled,
                checked,
            }: LynxCheckBoxStylesProps) => {
                if (disabled) {
                    return theme.colors.primary.blue200;
                } else if (checked) {
                    return theme.colors.primary.blue500;
                } else {
                    return theme.colors.neutrals.neutral200;
                }
            },

            borderRadius: theme.shape.borderRadius,
        },

        checkedIcon: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",

            "& svg": {
                fill: "white",
                width: ({ size }: LynxCheckBoxStylesProps) =>
                    size === "small" ? 11 : 16,
                height: ({ size }: LynxCheckBoxStylesProps) =>
                    size === "small" ? 8 : 12,
            },
        },
    })
);
